export { default } from "./GeneaologyPanel";
export { default as GeneaologyPanel } from "./GeneaologyPanel";
